import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/gumbel/cdf';
import __var_2__ from '@stdlib/stats/base/dists/gumbel/ctor';
import __var_3__ from '@stdlib/stats/base/dists/gumbel/entropy';
import __var_4__ from '@stdlib/stats/base/dists/gumbel/kurtosis';
import __var_5__ from '@stdlib/stats/base/dists/gumbel/logcdf';
import __var_6__ from '@stdlib/stats/base/dists/gumbel/logpdf';
import __var_7__ from '@stdlib/stats/base/dists/gumbel/mean';
import __var_8__ from '@stdlib/stats/base/dists/gumbel/median';
import __var_9__ from '@stdlib/stats/base/dists/gumbel/mgf';
import __var_10__ from '@stdlib/stats/base/dists/gumbel/mode';
import __var_11__ from '@stdlib/stats/base/dists/gumbel/pdf';
import __var_12__ from '@stdlib/stats/base/dists/gumbel/quantile';
import __var_13__ from '@stdlib/stats/base/dists/gumbel/skewness';
import __var_14__ from '@stdlib/stats/base/dists/gumbel/stdev';
import __var_15__ from '@stdlib/stats/base/dists/gumbel/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace gumbel
*/
var gumbel = {};

/**
* @name cdf
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/cdf}
*/
setReadOnly( gumbel, 'cdf', __var_1__);

/**
* @name Gumbel
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/ctor}
*/
setReadOnly( gumbel, 'Gumbel', __var_2__);

/**
* @name entropy
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/entropy}
*/
setReadOnly( gumbel, 'entropy', __var_3__);

/**
* @name kurtosis
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/kurtosis}
*/
setReadOnly( gumbel, 'kurtosis', __var_4__);

/**
* @name logcdf
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/logcdf}
*/
setReadOnly( gumbel, 'logcdf', __var_5__);

/**
* @name logpdf
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/logpdf}
*/
setReadOnly( gumbel, 'logpdf', __var_6__);

/**
* @name mean
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/mean}
*/
setReadOnly( gumbel, 'mean', __var_7__);

/**
* @name median
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/median}
*/
setReadOnly( gumbel, 'median', __var_8__);

/**
* @name mgf
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/mgf}
*/
setReadOnly( gumbel, 'mgf', __var_9__);

/**
* @name mode
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/mode}
*/
setReadOnly( gumbel, 'mode', __var_10__);

/**
* @name pdf
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/pdf}
*/
setReadOnly( gumbel, 'pdf', __var_11__);

/**
* @name quantile
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/quantile}
*/
setReadOnly( gumbel, 'quantile', __var_12__);

/**
* @name skewness
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/skewness}
*/
setReadOnly( gumbel, 'skewness', __var_13__);

/**
* @name stdev
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/stdev}
*/
setReadOnly( gumbel, 'stdev', __var_14__);

/**
* @name variance
* @memberof gumbel
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/gumbel/variance}
*/
setReadOnly( gumbel, 'variance', __var_15__);


// EXPORTS //
export default gumbel;

export { __var_1__ as cdf, __var_2__ as Gumbel, __var_3__ as entropy, __var_4__ as kurtosis, __var_5__ as logcdf, __var_6__ as logpdf, __var_7__ as mean, __var_8__ as median, __var_9__ as mgf, __var_10__ as mode, __var_11__ as pdf, __var_12__ as quantile, __var_13__ as skewness, __var_14__ as stdev, __var_15__ as variance};